import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "cooldown",
})
export class MinutesSecondsPipe implements PipeTransform {
  transform(value: number): string {
    const minutes: number = Math.floor(value / 60);
    const seconds: number = value % 60;
    const minutesString: string = minutes < 10 ? `${minutes}` : `${minutes}`;
    const secondsString: string = seconds < 10 ? `0${seconds}` : `${seconds}`;
    return `${minutesString}:${secondsString}`;
  }
}
